const API_BASE = process.env.REACT_APP_API_BASE;

const toTimestamp = (value, fallback) => {
  if (!value) return fallback;
  const ts = new Date(value).getTime();
  return Number.isNaN(ts) ? fallback : ts;
};

const normalizeCampaign = (campaign) => {
  if (!campaign || typeof campaign !== "object") {
    return null;
  }

  return {
    ...campaign,
    id: campaign.id || campaign.post_id || campaign.postId || null,
    title: campaign.title || "",
    description: campaign.description || "",
    ctaText: campaign.ctaText || campaign.cta_text || "Дознај повеќе",
    ctaUrl: campaign.ctaUrl || campaign.cta_url || "#",
    imageUrl: campaign.imageUrl || campaign.image_url || "",
    placements: Array.isArray(campaign.placements) ? campaign.placements : [],
    priority: Number(campaign.priority) || 0,
    dismissTtlHours: Number(campaign.dismissTtlHours || campaign.dismiss_ttl_hours) || 3,
    isActive: Boolean(campaign.isActive ?? campaign.is_active),
    startAt: campaign.startAt || campaign.start_at || null,
    endAt: campaign.endAt || campaign.end_at || null,
  };
};

const isCampaignActiveNow = (campaign) => {
  if (!campaign?.isActive) return false;
  const now = Date.now();
  const startAt = toTimestamp(campaign.startAt, Number.NEGATIVE_INFINITY);
  const endAt = toTimestamp(campaign.endAt, Number.POSITIVE_INFINITY);
  return startAt <= now && now <= endAt;
};

export async function getSponsoredCampaignByPlacement(placement) {
  if (!placement) return null;

  const response = await fetch(
    `${API_BASE}/sponsored-campaigns?placement=${encodeURIComponent(placement)}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );

  if (!response.ok) {
    return null;
  }

  const data = await response.json();
  const campaigns = (Array.isArray(data) ? data : [data])
    .map(normalizeCampaign)
    .filter(Boolean)
    .filter(isCampaignActiveNow);

  if (!campaigns.length) {
    return null;
  }

  campaigns.sort((a, b) => (b.priority || 0) - (a.priority || 0));
  return campaigns[0];
}

export async function trackSponsoredCampaignImpression(postId, payload = {}) {
  if (!postId) return;
  try {
    await fetch(`${API_BASE}/sponsored-campaigns/${postId}/impression`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch {
    // no-op
  }
}

export async function trackSponsoredCampaignClick(postId, payload = {}) {
  if (!postId) return;
  try {
    await fetch(`${API_BASE}/sponsored-campaigns/${postId}/click`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch {
    // no-op
  }
}
